import FileUploaderV2List from '@core/components/ApplyDialogV2/FileUploaderV2List'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import clsx from 'clsx'
import React from 'react'
import './ApplyV2ReviewApplyCv.scss'
import { useTranslation } from 'react-i18next'

interface ApplyV2ReviewApplyCv {
    className?: string
}

const baseClass = 'ApplyV2ReviewApplyCv'

function ApplyV2ReviewApplyCv({ className = '' }: ApplyV2ReviewApplyCv) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
        settingsData,
    } = useApplyV2Context()
    const { t } = useTranslation()
    const profileData = postProfileData?.data?.cv
    if (!profileData) {
        return (
            <div
                className={clsx(baseClass, className, {
                    [`${baseClass}--isEmpty`]: true,
                })}
            >
                {t('10699', 'No CV uploaded')}
            </div>
        )
    }
    return (
        <div className={`${baseClass} ${className}`}>
            <FileUploaderV2List
                files={profileData ? [profileData] : []}
                isShowDelete={false}
                isShowParseInfo={false}
            ></FileUploaderV2List>
        </div>
    )
}

export default ApplyV2ReviewApplyCv
